import baseApi from 'api/baseApi';
import { IReqChangeStatusCampaign } from 'modules/crm/interfaces/campaigns';
import { IPaginatedData } from 'common/interfaces/pagination';
import { ICampaignDto } from 'common/interfaces/campaign';

const campaignApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    changeCampaignStatus: builder.mutation<IPaginatedData<ICampaignDto>, IReqChangeStatusCampaign>({
      query: ({ id, active }) => ({
        url: `/api/v1/pt-campaign/${id}/active-status`,
        method: 'PATCH',
        data: { active },
      }),
    }),
  }),
});

export const { useChangeCampaignStatusMutation: useChangePTCRMCampaignStatus } = campaignApi;
export default campaignApi;
